<svg xmlns="http://www.w3.org/2000/svg" width="25" height="24" viewBox="0 0 25 24" fill="none">
<path fill-rule="evenodd" clip-rule="evenodd" d="M1.47949 3H23.4795V10H5.4795V19H19.4795V12H21.4795V21H3.4795V10H1.47949V3ZM3.4795 5V8H21.4795V5H3.4795ZM9.47949 13H15.4795V15H9.47949V13Z" fill="#143545"/>
</svg>